export default __webpack_public_path__ + "static/media/VFC_Jahresbericht_2019.1fec0416.pdf";